<template>
  <span>
    <el-select v-model="selectedField" placeholder="Please select">  
      <el-option
        v-for="field in [...fields].sort((a, b) => a.order - b.order)"
        :key="field.field"
        :label="field.title"
        :value="field.field">
      </el-option>
    </el-select>
    <el-select v-model="selectedOperator" placeholder="Please select" v-if="selectedField">
      <el-option
        v-for="operator in operators"
        :key="operator.id"
        :label="operator.title"
        :value="operator.id">
      </el-option>
    </el-select>

    <span v-if="selectedField && selectedOperator">
      <el-input class="text-input" v-if="currentField.input === 'text'" placeholder="Please input" v-model="selectedInput" />
      <el-input-number v-if="currentField.input === 'number'" placeholder="Please input" v-model="selectedInput" />
      <el-select v-if="currentField.input === 'select' || currentField.input === 'foreign_key'" v-model="selectedInput">
        <el-option
          v-for="option in currentField.options"
          :key="option.id"
          :label="option.value"
          :value="option.id">
        </el-option>
      </el-select>
    </span>
  </span>
</template>

<script>
export default {
  props: {
    fields: Array,
    required: true,
  },
  data: () => ({
    selectedField: null,
    selectedOperator: null,
    selectedInput: null,
    rows: [],
    searchMatchers: {
      exact: 'is',
      contains: 'contains',
      exists: 'exists',
    },
  }),
  computed: {
    field: {
      get() {
        return this.selectedField;
      },

      set(newField) {
        this.selectedField = newField;
      },
    },

    operators() {
      return (
        this.fieldFromId(this.selectedField).operators.map(operator => ({
          id: operator,
          title: this.searchMatchers[operator],
        })) || []
      );
    },

    currentField() {
      return this.fieldFromId(this.selectedField) || null;
    },
  },
  watch: {
    selectedField() {
      this.selectedOperator = null;
      this.selectedInput = null;
      this.emitChanges();
    },

    selectedOperator() {
      this.selectedInput = null;
      this.emitChanges();
    },

    selectedInput() {
      this.emitChanges();
    },
  },
  methods: {
    fieldFromId(fieldId) {
      return this.fields.filter(field => field.field === fieldId)[0];
    },

    emitChanges() {
      this.$emit('onFieldsChanged', {
        field: this.selectedField,
        operator: this.selectedOperator,
        input: this.selectedInput,
      });
    },
  },
};
</script>

<style scoped>
.text-input {
  width: 195px;
}
</style>



// WEBPACK FOOTER //
// SearchFieldSelect.vue?04c86a5d